'use strict';

class AccountDelete {
  constructor($window, originatorService, Notification) {
    this.$window = $window;
    this.originatorService = originatorService;
    this.Notification = Notification;
  }

  $onInit() {
    this.codes = [{
      value: 'TOO_EXPENSIVE',
      label: 'Tjenesten er for dyr'
    }, {
      value: 'OTHER',
      label: 'Annet'
    }, {
      value: 'BAD_SUPPORT',
      label: 'Dårlig kundestøtte'
    }, {
      value: 'DIFFERENT_SYSTEM',
      label: 'Nytt regnskapssystem (hvilket produkt?)'
    }];
    this.data = {
      reason: null,
      code: 'OTHER',
      password: null
    };
  }

  send() {
    this.originatorService.validateDelete()
      .then(() => {
        this.originatorService.delete(this.data)
          .then(() => {
            this.$window.sessionStorage.removeItem('originatorId');
            this.$window.location.href = '/';
          });
      });
  }

  downloadAllData() {
    this.originatorService.validate()
      .then((resp) => {
        if (resp && resp.data) {
          this.originatorService.downloadAllData('json');
        }
      });
  }
}

AccountDelete.$inject = ['$window', 'originatorService', 'Notification'];

const accountDelete = {
  controller: AccountDelete,
  template: `
    <h2>Slett alle mine data</h2>
    <h3>Dette vil deaktivere din konto og slette alle data tilknyttet din konto.</h3>
    <h4><i>Obs! Dette kan ikke reverseres, dataene vil forsvinne for godt!</i></h4>
    <div>Dersom du i stedet vil deaktivere kontoen uten å slette data, kan du gjøre det her: <a href="#/konto/deaktiver">Deaktiver konto</a>.</div>
    <div>Før du sletter dine data, kan du om ønskelig laste disse ned til din egen maskin: <a href="#/konto/last-ned">Last ned mine data</a>.</div>

    <fieldset>
      <div>
        <label for="code">Hvorfor sletter du din konto hos oss?</label>
        <select ng-model="$ctrl.data.code" ng-options="code.value as code.label for code in $ctrl.codes" id="code" required></select>
      </div>
      <div>
        <label for="reason">Kommentarer</label>
        <textarea name="reason" id="reason" ng-model="$ctrl.data.reason"></textarea>
      </div>
    </fieldset>

    <fieldset>
      <label for="password">Passord</label>
      <input type="password" name="password" id="password" ng-model="$ctrl.data.password" required>
    </fieldset>

    <a role="button" class="button secondary" href="#/konto">Avbryt</a>
    <button ng-click="$ctrl.send()" class="button alert"><i class="fa fa-trash"></i> Slett alle data</button>
  `
};

angular
  .module('SendRegning')
  .component('accountDelete', accountDelete)
  .config(($routeProvider) => {
    $routeProvider
      .when('/konto/slett', {
        title: 'Slett mine data',
        template: '<account-delete />',
        secure: true
      });
  });
